import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, Loader2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkMaskedLink = async () => {
      const path = location.pathname;
      if (!path || path === '/') {
        setChecking(false);
        return;
      }

      // Normalizar o path
      const normalizedPath = path.startsWith('/') ? path : `/${path}`;

      try {
        // Buscar em todas as páginas publicadas
        const { data: pages, error } = await supabase
          .from('pages')
          .select('id, org_id, published_schema')
          .eq('status', 'published');

        if (error) throw error;

        // Procurar o link mascarado em todas as páginas
        for (const page of pages || []) {
          if (!page.published_schema?.blocks) continue;

          for (const block of page.published_schema.blocks) {
            // Hero Block
            if (block.type === 'hero' && block.props.ctaLinkMasked) {
              if (block.props.ctaLinkMasked === normalizedPath || block.props.ctaLinkMasked === path) {
                if (block.props.ctaLink) {
                  window.location.href = block.props.ctaLink;
                  return;
                }
              }
            }

            // Banner Block
            if (block.type === 'banner' && block.props.linkMasked) {
              if (block.props.linkMasked === normalizedPath || block.props.linkMasked === path) {
                if (block.props.link) {
                  window.location.href = block.props.link;
                  return;
                }
              }
            }

            // CTA Block
            if (block.type === 'cta' && block.props.ctaLinkMasked) {
              if (block.props.ctaLinkMasked === normalizedPath || block.props.ctaLinkMasked === path) {
                if (block.props.ctaLink) {
                  window.location.href = block.props.ctaLink;
                  return;
                }
              }
            }

            // Footer Block
            if (block.type === 'footer' && block.props.links) {
              for (const link of block.props.links) {
                if (link.urlMasked === normalizedPath || link.urlMasked === path) {
                  if (link.url) {
                    window.location.href = link.url;
                    return;
                  }
                }
              }
            }
          }
        }

        // Se não encontrou, mostrar 404
        setChecking(false);
      } catch (error) {
        console.error('Erro ao verificar link mascarado:', error);
        setChecking(false);
      }
    };

    checkMaskedLink();
  }, [location.pathname]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <h1 className="text-6xl font-bold">404</h1>
        <p className="text-xl text-muted-foreground">Página não encontrada</p>
        <Button onClick={() => navigate("/")}>
          <Home className="w-4 h-4 mr-2" />
          Voltar para o início
        </Button>
      </div>
    </div>
  );
}
